import { render, staticRenderFns } from "./registerEmail.vue?vue&type=template&id=0135a8b8&scoped=true"
import script from "./registerEmail.vue?vue&type=script&lang=js"
export * from "./registerEmail.vue?vue&type=script&lang=js"
import style0 from "./registerEmail.vue?vue&type=style&index=0&id=0135a8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135a8b8",
  null
  
)

export default component.exports